<template>
  <div class="content-container">
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
      label-width="50px"
    >
      <div>
        <el-form-item label="申请日期" label-width="80px">
          <el-date-picker
            v-model="formInline.requestDate"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :clearable="true"
            width="180px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="抬头">
          <el-input
            v-model="formInline.title"
            placeholder="请输入发票抬头"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" label-width="60px">
          <el-input
            v-model="formInline.mobile"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="状态">
          <el-select
            v-model="formInline.receiptStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in RECEIPT_STATUS_ENUM"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="纳税人识别号" label-width="100px">
          <el-input
            v-model="formInline.taxpayerNo"
            placeholder="请输入纳税人识别号"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit"
            >查询</el-button
          >
        </el-form-item>
      </div>
    </el-form>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="createtime" width="100" label="申请日期">
        <template slot-scope="scope">
          <div v-html="scope.row.createtime"></div>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="抬头"></el-table-column>
      <el-table-column prop="taxpayerNo" label="纳税人识别号"></el-table-column>
      <el-table-column prop="amount" label="金额"></el-table-column>
      <el-table-column prop="remark" label="备注"> </el-table-column>
      <el-table-column prop="mobile" label="手机"> </el-table-column>
      <el-table-column prop="mailAddress" label="邮箱"> </el-table-column>
      <el-table-column prop="receiptStatus" label="发票状态">
        <template slot-scope="scope">
          <div
            v-html="$formatReceiptStatus(scope.row.receiptStatus)"
          ></div> </template
      ></el-table-column>
      <el-table-column prop="modifiedtime" width="100" label="操作时间">
        <template slot-scope="scope">
          <div v-html="scope.row.modifiedtime"></div> </template
      ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="updateStatus(scope.row.id, 2)"
            >拒绝</el-button
          >
          <el-button type="text" @click="updateStatus(scope.row.id, 1)"
            >开票</el-button
          >
        </template></el-table-column
      >
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    ></el-pagination>
  </div>
</template>

<script>
import enumObject from "../../plugins/enum";
//import { mapGetters } from "vuex";
// import moment from "moment";
export default {
  data() {
    return {
      formInline: {
        requestDate: null,
        title: "",
        taxpayerNo: "",
        mobile: "",
        receiptStatus: ""
      },
      tableData: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      RECEIPT_STATUS_ENUM: enumObject.RECEIPT_STATUS_ENUM
    };
  },

  methods: {
    onSubmit() {
      let queryModel = {
        createtimeFrom: Array.isArray(this.formInline.requestDate)
          ? this.$ToDateTimeString(this.formInline.requestDate[0])
          : null,
        createtimeTo: Array.isArray(this.formInline.requestDate)
          ? this.$ToDateTimeString(this.formInline.requestDate[1])
          : null,
        title: this.formInline.title,
        receiptStatus: this.formInline.receiptStatus,
        taxpayerNo: this.formInline.taxpayerNo,
        mobile: this.formInline.mobile,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      this.$axios(this.$urlMapping["查询发票申请"], {
        data: queryModel
      }).then(result => {
        //console.log(result);
        this.tableData = result.data;
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },

    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSubmit();
    },

    updateStatus(id, value) {
      let msg = "";
      if (value == 1) {
        msg = "确定同意开票吗？";
      } else if (value == 2) {
        msg = "确定拒绝开票吗？";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        let requestModel = {
          ids: [id],
          status: value
        };
        let result = await this.$axios(this.$urlMapping["审核发票"], {
          data: requestModel
        });
        console.log(result);
        this.onSubmit();
      });
    }
  },

  mounted() {
    this.onSubmit();
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-select {
  width: 202px;
}
</style>
